export default __webpack_public_path__ + "static/media/habano-2Closed.c639c922.jpg";